<template>
  <div>
    <p>{{ $t("GenerateCatalogFromExternalData.Intro.Part1") }}</p>
    <p>{{ $t("GenerateCatalogFromTextFile.Intro.Part2") }}</p>
    <p class="mb-0">
      {{
        $t("GenerateCatalogFromTextFile.Intro.Continue", {
          ButtonName: $t("Continue")
        })
      }}
    </p>
  </div>
</template>
